<template>
    <v-card>
        <div class="pa-4 rounded-lg bg-grey-lighten-4">
            <div class="d-flex justify-space-between mb-2">
                <span class="text-body-2 sm:text-body-1 md:text-body-1">
                    Item(s) total
                    <!-- ({{ cartItems.length }} item) -->
                </span>
                <span class="text-body-2 sm:text-body-1 md:text-body-1 font-weight-bold">
                    Rs. {{ formatPrice(grandTotal) }}
                </span>
            </div>

            <div class="d-flex justify-space-between mb-2">
                <span class="text-body-2 sm:text-body-1 md:text-body-1">Shipping</span>
                <span class="text-body-2 sm:text-body-1 md:text-body-1 text-success">Free</span>
            </div>

            <div class="d-flex justify-space-between mb-2">
                <span class="text-body-2 sm:text-body-1 md:text-body-1">Tax (0%)</span>
                <span class="text-body-2 sm:text-body-1 md:text-body-1">
                    Rs. {{ formatPrice(taxAmount) }}
                </span>
            </div>

            <v-divider class="my-3"></v-divider>

            <div class="d-flex justify-space-between">
                <span class="text-h6 sm:text-h5 md:text-h4 font-weight-bold">Total</span>
                <span class="text-h6 sm:text-h5 md:text-h4 font-weight-bold text-primary">
                    Rs. {{ formatPrice(totalWithTax) }}
                </span>
            </div>
            <!-- Button aligned to right -->
            <v-row justify="end" class="mt-4">
                <v-btn color="primary" size="large" prepend-icon="mdi-truck-fast" @click="proceedToCheckout"
                    :loading="loading">
                    {{ loading ? 'Processing...' : btnText }}
                </v-btn>
            </v-row>
        </div>

    </v-card>
</template>

<script setup>
defineProps({
    cartItems: Array,
    grandTotal: Number,
    taxAmount: Number,
    totalWithTax: Number,
    loading: Boolean,
    proceedToCheckout: Function,
    disabled: Boolean,
    btnText: {
        type: String,
        default: 'Proceed to Checkout'
    },
})

// Format price
function formatPrice(price) {
    return price?.toLocaleString("en-IN") ?? "0.00"
}
</script>